"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOfferedReportsSchema = exports.createOfferedReportSchema = exports.getLatestOfferedReportDateSchema = void 0;
const zod_1 = require("../zod");
const DayTime_schema_1 = require("./common/DayTime.schema");
exports.getLatestOfferedReportDateSchema = zod_1.z.object({
    dateFrom: zod_1.z.coerce.date(),
    dateTo: zod_1.z.coerce.date(),
    workingUnitLocationId: zod_1.z.coerce.number().int().positive(),
});
exports.createOfferedReportSchema = zod_1.z.object({
    date: DayTime_schema_1.dayTimeSchema,
    value: zod_1.z.coerce.number().nullable(),
    offeredClusterId: zod_1.z.coerce.number().int().positive(),
});
exports.createOfferedReportsSchema = zod_1.z.array(exports.createOfferedReportSchema).nonempty();
